import { FC } from 'react';
import { useAppDispatch, useAppSelector } from '../../../store';
import { FetchState } from '../../../store/fetchState';
import { getOptionsEmployee, selectOptionsEmployee, selectOptionsEmployeeState } from '../../../store/entities/optionsEmployee';
import { QcsAutocomplete } from './QcsAutocomplete';
import { CancelToken } from 'axios';
import { getFirstLastNameAutocomplete } from '../../../utils/format';
import { ReferenceDto } from '@api/models/employees/ReferenceDto';
import { UserRole } from '@api/models/enums/UserRole';

interface Props {
  filterOutNonHumanRoles?: boolean;
  allowedRoles?: UserRole[];
  multiple?: boolean;
  name: string;
  label?: React.ReactNode;
  disabled?: boolean;
  required?: boolean;
  onChange?: (value: ReferenceDto | ReferenceDto[] | null) => void;
}

export const EmployeeAutocomplete: FC<Props> = ({ filterOutNonHumanRoles, allowedRoles, multiple, name, label, disabled, required, onChange }) => {
  const dispatch = useAppDispatch();
  const optionsEmployee = useAppSelector(selectOptionsEmployee);
  const optionsEmployeeState = useAppSelector(selectOptionsEmployeeState);

  const loadOptions = (search: string | undefined, cancelToken: CancelToken) => {
    dispatch(getOptionsEmployee(filterOutNonHumanRoles, search, cancelToken, allowedRoles));
  };

  return (
    <QcsAutocomplete
      multiple={multiple}
      name={name}
      onChange={onChange}
      label={label}
      required={required}
      disabled={disabled}
      options={optionsEmployee}
      loading={optionsEmployeeState === FetchState.Loading}
      loadingError={optionsEmployeeState === FetchState.Error}
      loadOptions={loadOptions}
      getOptionId={(option: ReferenceDto) => option.id!}
      getOptionName={(option: any) => option.name + ' ' + (option?.lastName || '')}
      getValueIfNotFound={getFirstLastNameAutocomplete}
    />
  );
};
